import type { TConstraints } from '@feathr/rachis';

import { TargetableClass } from './targetable.types';
import type { ITargetableBase } from './targetable_base';
import { TargetableBase } from './targetable_base';

/** Maximum length for geofilter set name */
export const GEOFILTER_SET_NAME_MAX_LENGTH = 64;

/**
 * Interface for geo set targetables (multiple geo filters with included/excluded)
 */
export interface IGeoSetTargetable extends ITargetableBase {
  _cls: TargetableClass.geo_set;
  included_geo_filters?: string[];
  excluded_geo_filters?: string[];
  // Legacy support - some code may still use geo_filters, should be able to remove at the end of geofilters work
  geo_filters?: string[];
}

/**
 * GeoSetTargetable class for geo filter set targetables
 */
export class GeoSetTargetable extends TargetableBase<IGeoSetTargetable> {
  public override className = 'Targetable.GeoSetTargetable';

  public override getDefaults(): Partial<IGeoSetTargetable> {
    return {
      ...super.getDefaults(),
      _cls: TargetableClass.geo_set,
    };
  }

  public isDefault(defaultGeoSetId?: string): boolean {
    return this.id === defaultGeoSetId;
  }

  public override get constraints(): TConstraints<IGeoSetTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.geo_set],
      },
      name: {
        presence: {
          allowEmpty: false,
        },
        length: {
          maximum: GEOFILTER_SET_NAME_MAX_LENGTH,
          tooLong: '^Geofilter set name must be 64 characters or less.',
        },
      },
    };
  }
}
